__turbopack_context__.v({
  "className": "caveat_d924cca2-module__bNTTLW__className",
});
